import gql from 'graphql-tag'

export default gql`
  query getStoreInfo {
    getStoreInfo {
      store_error_msg
    }
  }
`
